import { render, staticRenderFns } from "./PhoneOutIcon.vue?vue&type=template&id=32f6bbce&"
import script from "./PhoneOutIcon.vue?vue&type=script&lang=js&"
export * from "./PhoneOutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports